export default __webpack_public_path__ + "static/media/exclusive-mini.9c0c1553.glb";